import { render, staticRenderFns } from "./shopPayChannel.vue?vue&type=template&id=77d9868a&scoped=true&"
import script from "./shopPayChannel.vue?vue&type=script&lang=js&"
export * from "./shopPayChannel.vue?vue&type=script&lang=js&"
import style0 from "./shopPayChannel.vue?vue&type=style&index=0&id=77d9868a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d9868a",
  null
  
)

export default component.exports